/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_Col_FieldsInputs */

const en_disp_col_fields = /** @type {(inputs: Disp_Col_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fields`)
};

const de_disp_col_fields = /** @type {(inputs: Disp_Col_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Felder`)
};

/**
* | output |
* | --- |
* | "Fields" |
*
* @param {Disp_Col_FieldsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_col_fields = /** @type {((inputs?: Disp_Col_FieldsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_Col_FieldsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_col_fields(inputs)
	return en_disp_col_fields(inputs)
});